'use client';

import { cn } from '@/app/utils';
import type { OfficialShowcaseSectionData } from '../../types';
import { MediaAsset } from '../MediaAsset';
import { PortableTextContent } from '../PortableTextContent';
import { SectionShell } from '../section-shared';

export function OverlayCard({
  activeIndex,
  activeTab,
  section,
  setActiveIndex,
  tabs,
}: {
  activeIndex: number;
  activeTab: OfficialShowcaseSectionData['tabs'][number];
  section: OfficialShowcaseSectionData;
  setActiveIndex: (index: number) => void;
  tabs: OfficialShowcaseSectionData['tabs'];
}) {
  return (
    <SectionShell>
      <div className="flex flex-col items-center gap-14 sm:gap-8">
        <h2 className="w-full text-center font-semibold text-[36px] text-white leading-[1.2] sm:text-[28px]">
          {section.title}
        </h2>

        <div className="relative mb-[60px] w-full sm:mb-0">
          <div className="w-full overflow-hidden rounded-3xl sm:rounded-2xl">
            <MediaAsset className="aspect-video" media={activeTab.media} />
          </div>

          <div className="-bottom-[60px] absolute right-7 w-[480px] rounded-[20px] border border-white/10 bg-[rgba(13,14,18,0.95)] p-8 backdrop-blur-sm sm:static sm:mt-6 sm:w-full sm:rounded-2xl sm:border-0 sm:bg-white/5 sm:p-6">
            <h3 className="font-semibold text-[28px] text-white leading-[1.25] sm:text-xl">{section.title}</h3>
            <PortableTextContent className="mt-3 text-[15px] text-white/55 leading-[1.6]" value={section.description} />

            <div className="mt-5 flex flex-wrap gap-2">
              {tabs?.map((tab, index) => {
                const active = index === activeIndex;
                return (
                  <button
                    key={tab._key || `${tab.tabLabel}-${index}`}
                    className={cn(
                      'h-[30px] rounded-full px-4 font-medium text-xs transition-colors',
                      active
                        ? 'bg-white text-black'
                        : 'bg-system-white08 text-white/55 hover:bg-system-white10 hover:text-white/80',
                    )}
                    onClick={() => setActiveIndex(index)}
                    type="button"
                  >
                    {tab.tabLabel}
                  </button>
                );
              })}
            </div>

            {section.button?.href && section.button?.label && (
              <a
                className="mt-6 inline-flex h-[45px] items-center justify-center rounded-full bg-[#0086FF] px-7 font-semibold text-sm text-white transition-colors hover:bg-[#0f91ff]"
                href={section.button.href}
                rel={/^https?:\/\//.test(section.button.href) ? 'noreferrer' : undefined}
                target={/^https?:\/\//.test(section.button.href) ? '_blank' : undefined}
              >
                {section.button.label}
              </a>
            )}
          </div>
        </div>
      </div>
    </SectionShell>
  );
}
